module.exports = __webpack_public_path__ + "img/sankaku_34_red.20021d48.png";